/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Agent_GoalInputs */

const en_us2_prescription_reason_agent_goal = /** @type {(inputs: Prescription_Reason_Agent_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer chose it for your goal`)
};

const pt_br2_prescription_reason_agent_goal = /** @type {(inputs: Prescription_Reason_Agent_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu personal escolheu para o seu objetivo`)
};

const es_419_prescription_reason_agent_goal = /** @type {(inputs: Prescription_Reason_Agent_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador lo eligió para tu objetivo`)
};

const pt_pt2_prescription_reason_agent_goal = /** @type {(inputs: Prescription_Reason_Agent_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treinador escolheu-o para o teu objetivo`)
};

const fr_fr2_prescription_reason_agent_goal = /** @type {(inputs: Prescription_Reason_Agent_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisi par ton coach pour ton objectif`)
};

const de_de2_prescription_reason_agent_goal = /** @type {(inputs: Prescription_Reason_Agent_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach hat sie für dein Ziel gewählt`)
};

const it_it2_prescription_reason_agent_goal = /** @type {(inputs: Prescription_Reason_Agent_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo coach l'ha scelto per il tuo obiettivo`)
};

/**
* | output |
* | --- |
* | "Your trainer chose it for your goal" |
*
* @param {Prescription_Reason_Agent_GoalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_agent_goal = /** @type {((inputs?: Prescription_Reason_Agent_GoalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Agent_GoalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_agent_goal(inputs)
	if (locale === "es-419") return es_419_prescription_reason_agent_goal(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_agent_goal(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_agent_goal(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_agent_goal(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_agent_goal(inputs)
	return en_us2_prescription_reason_agent_goal(inputs)
});
export { prescription_reason_agent_goal as "prescription.reason.agent_goal" }